import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_warehouses_win_or_separate_from_production_buildings'

export const dataPointDefinition = {
  retracedId: 'are_warehouses_win_or_separate_from_production_buildings',
  name: 'Are warehouses within or separate from production buildings?',
  description:
    'Warehouses can be part of the production building itself (e.g. separate areas under the same roof) or they can be completely separate buildings.  ',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Warehouses are separate buildings',
      key: 'WAREHOUSES_ARE_SEPARATE_BUILDINGS',
      slcpIndex: 1,
      slcpOptionName: 'fp-bs-4-opt',
    },
    {
      name: 'Warehouses are within production buildings',
      key: 'WAREHOUSES_ARE_WIN_PRODUCTION_BUILDINGS',
      slcpIndex: 2,
      slcpOptionName: 'fp-bs-4-opt',
    },
    {
      name: 'Warehouses are separate buildings AND within production buildings',
      key: 'WAREHOUSES_ARE_SEPARATE_BUILDINGS_AND_WIN_PRODUCTION_BUILDINGS',
      slcpIndex: 3,
      slcpOptionName: 'fp-bs-4-opt',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: [
          'WAREHOUSES_ARE_SEPARATE_BUILDINGS',
          'WAREHOUSES_ARE_WIN_PRODUCTION_BUILDINGS',
          'WAREHOUSES_ARE_SEPARATE_BUILDINGS_AND_WIN_PRODUCTION_BUILDINGS',
        ],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-bs-4',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 790,
  sectionId: '2.2.6.3',
  impactArea: 'Building and Operating Licenses',
  impactAreaId: 'BUILDING_AND_OPERATING_LICENSES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
